import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/src/app/homepage/components/CommercialInquirySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/src/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/src/components/ui/AppImage.tsx");
